import ProfileDetails from "../../slices/users/profile/ProfileDetails";
import StaffList from "../../slices/users/staff/StaffList";
import StaffDetails from "../../slices/users/staff/StaffDetails";
import AssignDepartmentList from "../../slices/users/assignDepartment/AssignDepartmentList";
import AssignDepartmentDetails from "../../slices/users/assignDepartment/AssignDepartmentDetails";

const usersReducer = {
    profileDetails: ProfileDetails,
    staffList: StaffList,
    staffDetails: StaffDetails,
    assignDepartmentList: AssignDepartmentList,
    assignDepartmentDetails: AssignDepartmentDetails,
};

export default usersReducer;